'use client';

import React from 'react';
import { Pointer } from 'lucide-react';

const FlexSection = () => {
  return (
    <section className="py-16 px-4 md:px-8 bg-primary-600 text-white">
      <div className="max-w-xl md:max-w-4xl mx-auto text-center flex flex-row items-center gap-6 font-bold text-2xl md:text-3xl font-funnel">
        <div>
          <Pointer className="text-accent w-12 h-12 rotate-90" />
        </div>
        <div>
          <p className="">
            Con <span className="text-accent">Trovanorma</span> trasformi un rischio costante in una
            certezza documentale.
          </p>
        </div>
        <div>
          <Pointer className="text-accent w-12 h-12 scale-y-[-1] rotate-90" />
        </div>
      </div>
    </section>
  );
};

export default FlexSection;
